import { render, staticRenderFns } from "./companyimg.vue?vue&type=template&id=59652b09&scoped=true&"
import script from "./companyimg.vue?vue&type=script&lang=js&"
export * from "./companyimg.vue?vue&type=script&lang=js&"
import style0 from "./companyimg.vue?vue&type=style&index=0&id=59652b09&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59652b09",
  null
  
)

export default component.exports